module.exports = __webpack_public_path__ + "img/fiber_smart_record.a99647bb.svg";